module.exports = __webpack_public_path__ + "media/18.ce39528c.mp3";